/**
 * 도메인별 기본 국가 설정
 */
const hostConfig = [
    { url: "http://localhost:3000" , locale: "KR"},
    { url: process.env.VUE_APP_KO_URL , locale: "KR"},
    { url: process.env.VUE_APP_MN_URL , locale: "MN"},
]

export default hostConfig